// extracted by css-extract-rspack-plugin
export default {"levelsGroup":"mA888","timeWrapper":"LYgym"};